import en from './en.json';
import kn from './kn.json';

export default {
  en: { translation: en },
  kn: { translation: kn },
};
